import { Injectable } from '@angular/core';
import { RecaptchaV3Adapter } from './recaptcha-v3.adapter';
import { Observable } from 'rxjs';

@Injectable()
export class RecaptchaV3Connector {
  constructor(protected adapter: RecaptchaV3Adapter) {}

  checkResponse(response: string): Observable<boolean> {
    return this.adapter.checkResponse(response);
  }
}
